<template>
  <div class="sitios" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
    <div class="form-row">
      <h1 class="col-8">Asignaciones Usuario Grupos</h1>
      <div class="col-3"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>
    <div class="row">

       <div class="col-12">
        <label class="col-form-label">Usuarios</label>
        <input
    class="filtro"
      v-model="searchUser"
      @input="handleSearch"
      placeholder="Filtrar..."
    />
    <multiselect
      ref="select"
      v-model="usersSeleccionados"
      placeholder="Seleccione los usuarios"
      label="name"
      track-by="id"
      :options="filteredUsers"
      :multiple="true"
      :closeOnSelect="false"
      select-label="Seleccionar"
      deselect-label="Remover"
    >
    </multiselect>
             <button class="btn btn-sm btn-outline-primary mt-1" @click="selectUsersAll">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAll">Limpiar</button>
     
      </div>
      
     <div class="col-12">
        <label class="col-form-label">Grupos</label>
        <input
    class="filtro"
      v-model="searchTerm"
      @input="handleSearch"
      placeholder="Filtrar..."
    />
    <multiselect
      ref="select"
      v-model="gruposSeleccionados"
      placeholder="Seleccione los dispositivos"
      label="name"
      track-by="id"
      :options="filteredGrupos"
      :multiple="true"
      :closeOnSelect="false"
      select-label="Seleccionar"
      deselect-label="Remover"
    >
    </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAllGrupos">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAllGrupos">Limpiar</button>
      </div>
     
      
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>

    

  </div>
</template>
<script>

import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
  data() {
    return {
     
      gruposObtenidos: [],
      gruposSeleccionados: [],
      gruposSeleccionados2: [],
      geocercasObtenidas: [],
      usersObtenidos:[],
      usersSeleccionados:[],
      usersSeleccionados2:[],
      geocercasSeleccionadas: '',
      geocercasSeleccionadas2: [],
      fechaInicio: '',
      horaInicio: '00:00',
      fechaFin: '',
      horaFin: '00:00',
      datosReporte: [],
      searchTerm: '',
      searchUser: '',
      searchSitio: '',
    }
  },
  watch: {
    dispositivosSeleccionados(newSelected) {
  
     
      this.dispositivosSeleccionados = newSelected;
     
    },
    usersSeleccionados(newSelected) {
  
     
  this.usersSeleccionados = newSelected;

},

gruposSeleccionados(newSelected) {
  
     
  this.gruposSeleccionados = newSelected;

},

},
  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades,
      catGeocercas: state => state.catalogos.catGeocercas
    }),

    ...mapState(["cargando"]),

    filteredGrupos() {
      return this.gruposObtenidos.filter(option => {
        
        return option.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
    },

    filteredUsers() {

     
return this.usersObtenidos.filter(option => {
  
  return option.name.toLowerCase().includes(this.searchUser.toLowerCase());
});
},

    formatearIdGrupo() {
       var index = 0;
       this.gruposSeleccionados2= [];
      for (let item of this.gruposSeleccionados) {
        this.gruposSeleccionados2.push(item.id);
        index++;
      }
      return this.gruposSeleccionados2;
    },
     formatearIdUser() {
       var index = 0;
       this.usersSeleccionados2= [];
      for (let item of this.usersSeleccionados) {
        this.usersSeleccionados2.push(item.id);
        index++;
      }
      return this.usersSeleccionados2;
    },
    
    formatearIdGeocerca() {
      
     var index = 0;
      for (let item of this.geocercasSeleccionadas) {
        this.geocercasSeleccionadas2.push(item.id);
        index++;
      }
      return this.geocercasSeleccionadas2;
    },

     formatearDatos() {
      var index1 = 0;
      var index2 = 0; 
     // var item;
      //var item5;
      //var item5;           
      
    //  for (var item4 of this.dispositivosSeleccionados) {
         //    console.log(item4.name);
      //}
        
              // for (var item5 of this.dispositivosSeleccionados) {     
                
                  //console.log(item5.name);
             //     index2++;
               /* for ( var item of this.datosReporte) {
                     
                      //item.datos.NoEmpleado = item.datos.NoEmpleado;
                      //item.maintenanceId = (item.serverTime).substr(11,8);
                      //item.serverTime = (item.serverTime).slice(0,10);
                      //console.log(this.formatearIds);
                    //  item.velocidad = (item.velocidad*1.852).toFixed()+" Km/h";
                      if(item.nombreEvento == 'geofenceEnter')
                      {
                        item.nombreEvento = "Entrada a sitio";
                      }
                      else
                      {
                        item.nombreEvento = "Salida de Sitio";
                      }
                      //item.NoEmpleado = item.NoEmpleado;
                      index1++;
                      
                    }*/
                    //var item5 = item5.name;
                    //  var item5.name = item5.name;
                    //index2++;
                    
    //}
          
     return this.datosReporte;
                       
      
    }
  },

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"],["obtenerGeocercas"]),
    ...mapMutations(["setearCargando"]),

    handleSearch() {
      // Puedes agregar lógica adicional aquí si es necesario
    },

    handleDeselectUser() {
      console.log(this.usersSeleccionados);
      this.usersSeleccionados = this.$refs.select.getSelected();

    },
    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, JSON.parse(localStorage.user))
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
      if ( this.gruposSeleccionados!='') {
      
        
        this.setearCargando(false);
        this.reporteUsuarioGrupo();
        /*if (this.gruposSeleccionados.length) {
          this.reporteGeocercasGrupos(fechaInicio, fechaFin);
        }else{
          this.reporteGeocercas(fechaInicio, fechaFin);
        }*/
      }
      else if ( this.usersSeleccionados.length =='' & this.gruposSeleccionados == '')
      {
        alert('Debe seleccionar, usuarios y grupos');
      }
      
      
    
    },

    reporteDispositivos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIds}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          console.log(this.datosReporte);
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    
    
     reporteUsuarioGrupo(){
   
      
      axios.post(`${url2}asignarusuariogrupos` ,{
        'usersid' : this.formatearIdUser,'groupid' : this.formatearIdGrupo }, {
        headers: {'content-type' : 'application/json'}}
        )
      .then(response => {
          this.datosReporte = response.data.datos;
          console.log(this.datosReporte)
          this.removeAll();
          this.setearCargando(false);
        
          //for (let item of this.datosReporte) {
        //(index == 0) ? data +=  item.id : data += item.id;
        //index++;
      //}
          //if (this.datosReporte.item == 0)
          //{
            
          //}
          //else{
           // this.setearCargando(false);
          //}
          
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    reporteGeocercas(){
      axios.post(`${url2}asignaciongeocerca` ,{
        'usersid' : this.formatearIdGeocerca,'idgeofence' : this.formatearIdGrupo }, {
        headers: {'content-type' : 'application/json'}})
      .then(response => {
          this.datosReporte = response.data.datos;
          this.removeAll();
          this.setearCargando(false);
          console.log(this.datosReporte)
          //for (let item of this.datosReporte) {
        //(index == 0) ? data +=  item.id : data += item.id;
        //index++;
      //}
          //if (this.datosReporte.item == 0)
          //{
            
          //}
          //else{
           // this.setearCargando(false);
          //}
          
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    
     reporteGeocercasGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/events?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },

    reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

   
    
    selectAllGrupos() {
      this.gruposSeleccionados = [];
      for (let item of this.filteredGrupos) {
          this.gruposSeleccionados.push(item);
      }
    },
    
    selectGeocercasAll() {
      this.geocercasSeleccionadas = [];
      for (let item of this.geocercasObtenidas) {
          this.geocercasSeleccionadas.push(item);
      }
    },
    selectUsersAll() {
      this.usersSeleccionados = [];
      for (let item of this.filteredUsers) {
          this.usersSeleccionados.push(item);
      }
    
    },

    removeAll() {
      this.usersSeleccionados = [];
      this.usersSeleccionados2 = [];
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = []; 
      this.geocercasSeleccionadas = [];         
      this.geocercasSeleccionadas2 = [];  
    },
    
    removeAllGrupos() {
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = [];
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['nombreUnidad', 'tipoSitio', 'sitio', 'nombreEvento', 'fecha'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'Tipo de Sitio';
        data['C1'].v = 'Sitio';
        data['D1'].v = 'Evento';
        data['E1'].v = 'Fecha';
        //data['F1'].v = 'Hora';
        //data['G1'].v = 'odometroFinal';

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    
    obtenerGrupos() {
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    
     obtenerGeocercas() {
      this.setearCargando(true);
      axios.get(`${url}geofences`, JSON.parse(localStorage.user))
        .then(response => {
          this.geocercasObtenidas = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
    obtenerUsuarios() {
      this.setearCargando(true);
      axios.get(`${url}users`, JSON.parse(localStorage.user))
        .then(response => {
          this.usersObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
   
    this.obtenerGrupos();
    this.obtenerGeocercas();
     this.obtenerUsuarios();
    // this.obtenerSesion();
  },

  mounted() {
    // this.obtenerKilometraje();
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .sitios{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>